module.exports = __webpack_public_path__ + "media/images/nicklpass-logo-31cdd11005e8f5300df03a89dc8053d0.svg";